<div class="maintenance-overlay" *ngIf="maintenanceService.maintenanceMode()">
  <div class="content-wrapper" [class.success-state]="maintenanceService.recovered()">

    <img class="brand-logo" src="electa_logo.svg" alt="Electa" />

    <!-- Maintenance State -->
    <ng-container *ngIf="!maintenanceService.recovered(); else recoveredState">
      <nz-result
        [nzIcon]="customIcon"
        nzStatus="info"
        [nzTitle]="'common.kurze_verschnaufpause' | translate"
        [nzSubTitle]="'common.wir_machen_electa_gerade_noch_besser' | translate">
      </nz-result>

      <ng-template #customIcon>
        <span class="brand-icon pulse-animation">
          <span nz-icon nzType="coffee" nzTheme="outline"></span>
        </span>
      </ng-template>

      <div class="recovery-progress" role="status" aria-live="polite">
        <div class="progress-dots" [class.idle]="maintenanceService.recoveryProgress() === 0">
          <span class="dot" *ngFor="let dot of [1, 2, 3]"
                [class.active]="dot <= maintenanceService.recoveryProgress()">
          </span>
        </div>
        <span class="progress-text">
          {{ statusKey() | translate }}
        </span>
        <button
          nz-button
          nzType="link"
          nzSize="small"
          class="retry-button  desktop-button"
          (click)="checkNow()">
          {{ 'maintenance.check_now' | translate }}
        </button>
      </div>
    </ng-container>

    <!-- Recovered State -->
    <ng-template #recoveredState>
      <div role="status" aria-live="polite">
        <nz-result
          [nzIcon]="successIcon"
          nzStatus="success"
          [nzTitle]="'common.wir_sind_zurck' | translate"
          [nzSubTitle]="'common.vielen_dank_fr_ihre_geduld_electa' | translate">
        </nz-result>
      </div>

      <ng-template #successIcon>
        <span class="success-icon slide-up-animation">
          <span nz-icon nzType="check-circle" nzTheme="fill"></span>
        </span>
      </ng-template>
    </ng-template>

  </div>
</div>
